<script setup lang="ts">
import { ref, computed, onBeforeMount, onMounted, watch } from 'vue'
import ManagementCard from '~/components/management/ManagementCard.vue'

interface Props {
    data: any
}
const props = defineProps<Props>()
</script>

<template>
    <section class="management">
        <div class="container">
            <h1 class="management__title">Менеджмент компании AKTIVO</h1>
            <div class="management__subtitle">Наша цель — сделать для вас процесс инвестирования простым, понятным и доступным</div>
            <div class="management__wrapper">
                <div class="management__list">
                    <div class="management__item" v-for="(item, key) in props.data">
                        <ManagementCard 
                            :name="item.name"
                            :post="item.post"
                            :code="key"
                            :imagePath="`/img/management/${key}.jpg`"
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.management {
    padding-top: calc(65px + 54px);
    margin-top: calc(-65px - 54px);
    background-color: #E1E5EA;

    &__title {
        font-size: 16px;
        line-height: 1.25;
        font-family: 'Muller', sans-serif;
        font-weight: 800;
        text-transform: uppercase;
        color: #162133;
        margin-top: 0;
        margin-bottom: 8px;
    }

    &__subtitle {
        color: #162133;
        font-size: 12px;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 16px;
    }

    &__list {
        width: 100%;
    }

    &__item {
        width: 100%;
        margin-bottom: 8px;

        &:last-child {
            margin-bottom: 0;
        }
    }
}

@media screen and (min-width: 767.98px) {
    .management {
        &__title {
            font-size: 40px;
            font-weight: 700;
            line-height: 100%;
            text-transform: none;
        }

        &__subtitle {
            font-size: 16px;
            font-weight: 500;
            line-height: 140%;
            margin-bottom: 24px;
        }

        &__list {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: wrap;
            width: calc(100% + 16px);
            margin: 0 -8px -16px;
        }

        &__item {
            width: calc(50% - 16px);
            margin: 0 8px 16px;
            align-self: stretch;

            &:last-child {
                margin-bottom: 16px;
            }
        }
    }
}

@media screen and (min-width: 1199.98px) {
    .management {
        &__item {
            width: calc(25% - 16px);
        }
    }
}

@media screen and (min-width: 1360px) {
    .management {
        padding-top: calc(65px + 100px);
        margin-top: calc(-65px - 100px);

        &__subtitle {
            margin-bottom: 40px;
        }
    }
}
</style>